import staticConfiguration from "./static.config"

export default defineAppConfig({
  ...staticConfiguration,
  author: "Antoine Cordelois",
  url: "https://paris-iea.fr",
  lang: {
    locales: ["en", "fr"],
    default: "en",
  },
  list: {
    modules: [
      "events",
      "news",
      "people",
      "projects",
      "fellowships",
      "publications",
      "actions",
      "disciplines",
      "apps",
      "affiliations",
      "files",
      "mailing",
      "tags",
      /*    "users", */
    ],
  },
  form: {
    modules: [
      "events",
      "news",
      "people",
      "projects",
      "fellowships",
      "publications",
      "actions",
      "disciplines",
      "apps",
      "affiliations",
      "files",
      "mailing",
      "tags",
      /*    "users", */
    ],
  },
  sitemap: {
    // Navigation menu items based on the pages directory structure
    menu: [
      {
        title: "Actions",
        icon: "mdi-cog",
        color: "#FF9800",
      },
      {
        title: "Affiliations",
        icon: "mdi-domain",
        color: "#3F51B5",
      },
      {
        title: "Apps",
        icon: "mdi-application",
        color: "#009688",
      },
      {
        title: "Disciplines",
        icon: "mdi-school-outline",
        color: "#8BC34A",
      },
      {
        title: "Events",
        icon: "mdi-calendar-multiple",
        color: "#E91E63",
      },
      {
        title: "Fellowships",
        icon: "mdi-school",
        color: "#9C27B0",
      },
      {
        title: "Files",
        icon: "mdi-file-multiple",
        color: "#607D8B",
      },
      {
        title: "Mailing",
        icon: "mdi-email-multiple",
        color: "#00BCD4",
      },
      {
        title: "News",
        icon: "mdi-newspaper",
        color: "#F44336",
      },
      {
        title: "People",
        icon: "mdi-account-group",
        color: "#4CAF50",
      },
      {
        title: "Projects",
        icon: "mdi-folder-multiple",
        color: "#FFC107",
      },
      {
        title: "Publications",
        icon: "mdi-book-open-variant",
        color: "#795548",
      },
      {
        title: "Tags",
        icon: "mdi-tag-multiple",
        color: "#9E9E9E",
      },
      /*       {
        title: "Users",
        icon: "mdi-account-cog",
        color: "#2196F3",
      }, */
    ],
  },
})
